import '@module-federation/nextjs-mf/src/include-defaults';
import { AppProps } from 'next/app';
import Head from 'next/head';
import { Suspense } from 'react';
import React from 'react';
import { RecoilRoot } from 'recoil';

import { ChakraProvider } from '@chakra-ui/react';

import { Loader } from '@asa/asasqt-microfrontend-components/dist/layout/animate/Loader';
import { Viewport } from '@asa/asasqt-microfrontend-components/dist/layout/ui/Viewport';

import { Providers } from '@/Providers';
import theme from '@/theme';

import favicon_192x192 from '../../public/android-chrome-192x192.png';
import favicon_180x180 from '../../public/apple-touch-icon.png';
import favicon from '../../public/favicon.ico';
import favicon_32x32 from '../../public/favicon_32x32.ico';
import favicon_48x48 from '../../public/favicon_48x48.ico';
import favicon_256x256 from '../../public/favicon_256x256.ico';
import favicon_150x150 from '../../public/mstile-150x150.png';

const App = ({ Component, pageProps }: AppProps) => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Head>
        <title>
          ASA SQT - Service Quotation Tool for Authorized Mitsubishi Dealers
        </title>
        <meta
          name="description"
          content={`Create Quotations for Periodic Inspections & Repairs. Do Vehicle Health Checks online © ${currentYear} LexCom Informationssysteme GmbH`}
        />
        <meta name="msapplication-config" content={`/browserconfig.xml`} />
        <link rel="manifest" href={`/manifest.json`} />

        <link rel="shortcut icon" href={favicon.src} type="image/x-icon" />
        <link
          rel="icon"
          href={favicon_32x32.src}
          sizes="32x32"
          type="image/x-icon"
        />
        <link
          rel="icon"
          href={favicon_48x48.src}
          sizes="48x48"
          type="image/x-icon"
        />
        <link
          rel="icon"
          href={favicon_256x256.src}
          sizes="256x256"
          type="image/x-icon"
        />

        <link
          rel="apple-touch-icon"
          href={favicon_180x180.src}
          type="image/png"
        />

        {/* Android Chrome Icons */}
        <link
          rel="icon"
          type="image/png"
          sizes="192x192"
          href={favicon_192x192.src}
        />

        {/* Microsoft Tiles */}
        <meta name="msapplication-TileColor" content="#FFFFFF" />
        <meta name="msapplication-TileImage" content={favicon_150x150.src} />
      </Head>
      <Suspense fallback={<Loader />}>
        <ChakraProvider
          theme={{
            ...theme,
          }}
        >
          <RecoilRoot>
            <Providers>
              <Viewport>
                <Component {...pageProps} />
              </Viewport>
            </Providers>
          </RecoilRoot>
        </ChakraProvider>
      </Suspense>
    </>
  );
};
export default App;
